/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/forbid-prop-types */
import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { some } from 'lodash';
import TableCell from '@material-ui/core/TableCell';
import QueryString from 'query-string';
import PropTypes from 'prop-types';
import moment from 'moment';
import Table from '../../../shared/components/MaterialTable';
import { getAllEmailTemplates } from '../../../redux/actions/emailTemplateActions';
import { isUserAllowed } from '../../../shared/utils';
import { ROLES } from '../../../helper/constants';

const headers = [
  { id: 'title', label: 'Titulo' },
  { id: 'dateCreate', label: 'Fecha creación' },
  { id: 'dateUpdate', label: 'Ultima actualización' },
];

class TemplatesList extends PureComponent {
  constructor() {
    super();
    this.state = {
      page: 0,
      limit: 10,
    };
  }

  componentDidMount() {
    if (!isUserAllowed(ROLES.auditor) && !some(headers, e => e.id === 'accions')) {
      headers.push({ id: 'accions', label: 'Acciones' });
    }
    let { page = 1, limit = 10 } = QueryString.parse(this.props.location.search);
    const query = {};
    if (page && !Number.isNaN(page)) {
      page = parseInt(page, 10) - 1;
      Object.assign(query, { page: page + 1 });
    }
    if (limit && !Number.isNaN(limit)) {
      limit = parseInt(limit, 10);
      Object.assign(query, { limit });
    }
    this.setState({ page, limit });
    this.props.getAllEmailTemplates({ ...query });
  }

  onChangePage = (page) => {
    this.setState({ page });
    const query = QueryString.parse(this.props.location.search);
    this.props.history.push(`/templates?${QueryString.stringify({ ...query, page: page + 1 })}`);
    this.props.getAllEmailTemplates({ ...query, page: page + 1 });
  }

  onChangeLimit = (limit) => {
    this.setState({ limit });
    const query = QueryString.parse(this.props.location.search);
    this.props.history.push(`/templates?${QueryString.stringify({ ...query, limit })}`);
    this.props.getAllEmailTemplates({ ...query, limit });
  }

  render() {
    const { page, limit } = this.state;
    const {
      list, loading, count, action,
    } = this.props;
    const data = list
      .map(template => ({
        id: template._id,
        code: template.code,
        cells: (
          <Fragment>
            <TableCell className="material-table__cell" style={{ borderBottom: '0px' }} align="left">
              {template.title}
            </TableCell>
            <TableCell className="material-table__cell" style={{ borderBottom: '0px' }} align="left">
              {moment(template.createdAt).format('DD/MM/YYYY, HH:mm')}
            </TableCell>
            <TableCell className="material-table__cell" style={{ borderBottom: '0px' }} align="left">
              {moment(template.updatedAt).format('DD/MM/YYYY, HH:mm')}
            </TableCell>
            {!isUserAllowed(ROLES.auditor) &&
              <TableCell className="material-table__cell" align="left">
                <button className="table-button" type="button" onClick={() => action('edit', template)}>
                  <span
                    className="lnr lnr-lnr lnr-pencil"
                    style={{
                      fontSize: '20px', fontWeight: 'bold', cursor: 'pointer', color: '#000',
                    }}
                  />
                </button>
                <button className="table-button" type="button" onClick={() => action('delete', template)} style={{ marginLeft: '15%' }}>
                  <span
                    className="lnr lnr-lnr lnr-trash"
                    style={{
                      fontSize: '20px', fontWeight: 'bold', cursor: 'pointer', color: '#000',
                    }}
                  />
                </button>
              </TableCell>}
          </Fragment>
        ),
      }));
    return (
      <Table
        cargando={loading}
        data={data}
        headers={headers}
        page={page}
        rowsPerPage={limit}
        selected={[]}
        total={count}
        onChangePage={this.onChangePage}
        onChangeRowsPerPage={this.onChangeLimit}
      />
    );
  }
}

TemplatesList.propTypes = {
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  action: PropTypes.func.isRequired,
  getAllEmailTemplates: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  list: PropTypes.array,
  loading: PropTypes.bool,
  location: PropTypes.object.isRequired,
};

TemplatesList.defaultProps = {
  count: 0,
  list: [],
  loading: false,
};

const mapStateToProps = ({ emailTemplate }) => ({
  list: emailTemplate.allEmailTemplates,
  loading: emailTemplate.loadingAllTemplates,
  count: emailTemplate.countEmailTemplates,
});

const mapDispatchToProps = {
  getAllEmailTemplates,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(TemplatesList);
